import React from 'react';
import { Link } from 'react-router-dom';

const OnboardingConfirmation: React.FC = () => (
  <div className="max-w-lg bg-white rounded-lg shadow p-8 text-center">
    <h2 className="text-2xl font-bold mb-4">Request received! Here's what happens next…</h2>
    <p className="mb-4 text-gray-700">Our team will review your request and get started. You'll receive updates in your dashboard and by email.</p>
    <p className="mb-4 text-gray-700">Estimated turnaround time: <span className="font-semibold">1-3 business days</span></p>
    <p className="mb-6 text-gray-700">Need help? <Link to="/faq" className="text-primary underline">Read our FAQ</Link> or <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer" className="text-primary underline">watch the onboarding video</a>.</p>
    <Link to="/dashboard" className="bg-primary text-white px-6 py-2 rounded font-semibold">Go to Dashboard</Link>
  </div>
);

export default OnboardingConfirmation; 